module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp23_3.a5f822d4.png";